var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"checkbox"},[_vm._t("default"),_c('div',{staticClass:"checkbox__button"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.state},on:{"change":function($event){return _vm.$emit('changeCheckbox', $event.target.checked)}}}),_c('span',{staticClass:"slider round"})])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }